import type { FC, PropsWithChildren } from 'react';
import { useEffect } from 'react';
import type { COLOR } from '@george-labs.com/design-system/types/utilsTS/color';

import { useGlobalColor } from '@shared/core-ui-layout';
import { Outlet } from '@luna/router';

type Props = {
    color?: COLOR;
};

export const ProductContext: FC<PropsWithChildren<Props>> = ({ color, children = <Outlet /> }) => {
    const { setValue, resetValue } = useGlobalColor();

    useEffect(() => {
        // @ts-expect-error to-fix
        setValue(color?.toLowerCase());

        return resetValue;
    }, [color]);
    return children;
};
